import { render, staticRenderFns } from "./UpdateUserModal.vue?vue&type=template&id=ecf42726&scoped=true&"
import script from "./UpdateUserModal.vue?vue&type=script&lang=js&"
export * from "./UpdateUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf42726",
  null
  
)

export default component.exports